module.exports = __webpack_public_path__ + "img/lg_ring_y_i_1_1@2x.9e588314.png";